
import { createSupabase } from '@project/db';

/**
 * Supabase client instance configured with environment credentials.
 * Used for authentication and database operations throughout the app.
 */
export const supabase = createSupabase(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY
);